import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultancy-requests-index-route.tsx
var LazyConsultancyRequestsIndexRoute = lazy(() => import("./consultancy-requests-index-route-D-Eb7b7L.js").then((n) => n.n).then((module) => ({ default: module.ConsultancyRequestsIndexRoute })));
function ConsultancyRequestsIndexRoute({ route, ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyConsultancyRequestsIndexRoute, {
			route,
			...props
		})
	});
}
var useConsultancyRequestsIndexRoute = () => {
	return useMemo(() => ({ "consultancy-requests-index-route": { component: ConsultancyRequestsIndexRoute } }), []);
};
//#endregion
export { useConsultancyRequestsIndexRoute };
